// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aeps-div-two {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 2.5rem 0 2.5rem 0;
}

.aeps-div-three {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 2.5rem 0 2.5rem 0;
}

.aeps-div-two-title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;
}

.aeps-div-four {
  padding: 2.5rem 0 2.5rem 0;
}

.aeps-div-four-sub {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 2rem 0 2rem 0;
}

.aeps-div-five-sub {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.features-container {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
  padding: 3rem 0 3rem 0;
}

.features-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  /* height: 100%; */
}

.pos-div-one {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 2.5rem 0 2.5rem 0;
}

.pos-steps {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.grid-pos-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.main-pos-content-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 0 2rem 0;
}

.main-pos-img-div {
  position: relative;
}

.pos-img-div {
  background-color: #635ad9;
  padding: 12px;
  border-radius: 100%;
  width: 85px;
  height: 85px;
}

.pos-index {
  background-color: rgb(54, 48, 48);
  color: white;
  text-align: center;
  border-radius: 100%;
  width: 22px;
  height: 22px;
  position: absolute;
  top: 0;
  left: 0;
}

.pos-content {
  margin-top: 1rem;
  text-align: center;
}

/* Mobile ATM Page CSS */
.matm-heading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.matm-heading p {
  text-align: center;
  max-width: 50rem;
}

.matm-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.matm-content p {
  text-align: center;
  max-width: 52rem;
}

/* Indo Nepal Page CSS */
.in-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 2rem;
}

.in-content p {
  text-align: center;
}

.new-innp-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 2.5rem 0 2.5rem 0;
}

.protect-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.protect-section-div {
  display: flex;
  align-items: center;
  gap: 2rem;
  background-color: #635ad9;
  padding: 1rem;
  border-radius: 10px;
  color: white;
}

.protect-section-div:hover {
  background-color: #635ad9db;
}

/* PAN UTI Page CSS */
.pan-uti-heading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.uti-heading {
  padding: 2.5rem 0 2.5rem 0;
}

.uti-heading-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.uti-main-details-div {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.uti-details-card {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 1.5rem;
}

.uti-details-img-div {
  background-color: #635ad9;
  border-radius: 100%;
  padding: 0.5rem;
}

.uti-details-img-div > div {
  width: 45px;
  height: 45px;
  background-color: white;
  border-radius: 100%;
  padding: 0.4rem;
}

.pan-app-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.pan-app-details p {
  text-align: center;
  max-width: 55rem;
}

.pan-app-card-div {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 3rem 0 5rem 0;
}

.pan-app-img-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pan-app-img-div img {
  width: 4rem;
  height: 4rem;
}

.pan-app-card {
  background-color: rgb(240, 249, 250);
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */
}

.pan-app-card:hover {
  background-color: rgb(222, 244, 246);
}

@media (min-width: 640px) {
  .uti-details-img-div > div {
    width: 75px;
    height: 75px;
    padding: 0.8rem;
  }
}

@media (min-width: 1280px) {
  .aeps-div-two {
    flex-direction: row;
    padding: 5rem 0 5rem 0;
  }
  .aeps-div-three {
    flex-direction: row;
    padding: 5rem 0 5rem 0;
  }
  .aeps-div-four {
    padding: 5rem 0 5rem 0;
  }
  .aeps-div-four-sub {
    flex-direction: row;
  }
  .pos-div-one {
    flex-direction: row;
    padding: 5rem 0 5rem 0;
  }
  .new-innp-section {
    padding: 5rem 0 5rem 0;
  }
  .uti-heading {
    padding: 5rem 0 5rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/FinTech/FinTech.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,yCAAyC,EAAE,yBAAyB;AACtE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".aeps-div-two {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  padding: 2.5rem 0 2.5rem 0;\n}\n\n.aeps-div-three {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  padding: 2.5rem 0 2.5rem 0;\n}\n\n.aeps-div-two-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.aeps-div-four {\n  padding: 2.5rem 0 2.5rem 0;\n}\n\n.aeps-div-four-sub {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  padding: 2rem 0 2rem 0;\n}\n\n.aeps-div-five-sub {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n}\n\n.features-container {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 3rem;\n  padding: 3rem 0 3rem 0;\n}\n\n.features-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  /* height: 100%; */\n}\n\n.pos-div-one {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  padding: 2.5rem 0 2.5rem 0;\n}\n\n.pos-steps {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.grid-pos-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.main-pos-content-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem 0 2rem 0;\n}\n\n.main-pos-img-div {\n  position: relative;\n}\n\n.pos-img-div {\n  background-color: #635ad9;\n  padding: 12px;\n  border-radius: 100%;\n  width: 85px;\n  height: 85px;\n}\n\n.pos-index {\n  background-color: rgb(54, 48, 48);\n  color: white;\n  text-align: center;\n  border-radius: 100%;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.pos-content {\n  margin-top: 1rem;\n  text-align: center;\n}\n\n/* Mobile ATM Page CSS */\n.matm-heading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.matm-heading p {\n  text-align: center;\n  max-width: 50rem;\n}\n\n.matm-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.matm-content p {\n  text-align: center;\n  max-width: 52rem;\n}\n\n/* Indo Nepal Page CSS */\n.in-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 2rem;\n}\n\n.in-content p {\n  text-align: center;\n}\n\n.new-innp-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 2.5rem 0 2.5rem 0;\n}\n\n.protect-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.protect-section-div {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  background-color: #635ad9;\n  padding: 1rem;\n  border-radius: 10px;\n  color: white;\n}\n\n.protect-section-div:hover {\n  background-color: #635ad9db;\n}\n\n/* PAN UTI Page CSS */\n.pan-uti-heading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.uti-heading {\n  padding: 2.5rem 0 2.5rem 0;\n}\n\n.uti-heading-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.uti-main-details-div {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.uti-details-card {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.uti-details-img-div {\n  background-color: #635ad9;\n  border-radius: 100%;\n  padding: 0.5rem;\n}\n\n.uti-details-img-div > div {\n  width: 45px;\n  height: 45px;\n  background-color: white;\n  border-radius: 100%;\n  padding: 0.4rem;\n}\n\n.pan-app-details {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pan-app-details p {\n  text-align: center;\n  max-width: 55rem;\n}\n\n.pan-app-card-div {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  padding: 3rem 0 5rem 0;\n}\n\n.pan-app-img-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.pan-app-img-div img {\n  width: 4rem;\n  height: 4rem;\n}\n\n.pan-app-card {\n  background-color: rgb(240, 249, 250);\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */\n}\n\n.pan-app-card:hover {\n  background-color: rgb(222, 244, 246);\n}\n\n@media (min-width: 640px) {\n  .uti-details-img-div > div {\n    width: 75px;\n    height: 75px;\n    padding: 0.8rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .aeps-div-two {\n    flex-direction: row;\n    padding: 5rem 0 5rem 0;\n  }\n  .aeps-div-three {\n    flex-direction: row;\n    padding: 5rem 0 5rem 0;\n  }\n  .aeps-div-four {\n    padding: 5rem 0 5rem 0;\n  }\n  .aeps-div-four-sub {\n    flex-direction: row;\n  }\n  .pos-div-one {\n    flex-direction: row;\n    padding: 5rem 0 5rem 0;\n  }\n  .new-innp-section {\n    padding: 5rem 0 5rem 0;\n  }\n  .uti-heading {\n    padding: 5rem 0 5rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
